import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/employee/[id]/dearest/book/page";

export const Route = createFileRoute("/employee/$id/dearest/book/")({
  component: Page,
});
